import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold mb-2" }, "Wybrane Ieki:", -1)
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "text-2xl text-primary uppercase" }
const _hoisted_6 = {
  key: 0,
  class: "h-5 w-5 text-primary",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("g", { id: "Group 93" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    d: "M8.11097 15.2222C12.0382 15.2222 15.2219 12.0385 15.2219 8.1111C15.2219 4.18375 12.0382 1 8.11097 1C4.18369 1 1 4.18375 1 8.1111C1 12.0385 4.18369 15.2222 8.11097 15.2222Z",
    stroke: "#939393",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector_2",
    d: "M16.9994 17L13.1328 13.1333",
    stroke: "#939393",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "animate-spin h-5 w-5 text-primary",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "9",
  cy: "9",
  r: "8",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M9 1A8 8 0 019 17V13a4 4 0 010-8V1z"
}, null, -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "SearchForm__list" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", { class: "text-primary underline my-1 md:mt-0 md:ml-4 text-sm" }, "Dodaj Iek", -1)
const _hoisted_15 = ["onClick"]

import { ref, watch } from 'vue';
import axios from 'axios';


export default {
  __name: 'Search',
  props: {
  selectedMedications: {
    type: Array,
    required: true,
  },
  hasErrors: {
    type: Boolean,
    required: true,
  },
},
  emits: ['addItem'],
  setup(__props, { emit }) {

const props = __props;



const isOpen = ref(false);
const search = ref('');
const isLoading = ref(false);
const searchResults = ref([]);
const searchError = ref(false);

let controller = new AbortController();
let timeout = null;

const toggleIsOpen = (status) => {
  setTimeout(() => {
    isOpen.value = status;
  }, 0);
};

const validateSearch = () => {
  if (!searchResults.value.length || !search.value) {
    searchError.value = true;
  } else {
    searchError.value = false;
  }
};

const performSearch = () => {
  clearTimeout(timeout);
  if (search.value.length > 1) {
    if (controller) {
      controller.abort();
      controller = null;
      isLoading.value = false;
    }
    controller = new AbortController();
    timeout = setTimeout(() => {
      isLoading.value = true;
      axios
        .get(`${jsData.siteUrl}/wp-json/doctor/v1/medications-list?search=${search.value}`, {
          signal: controller.signal,
        })
        .then((response) => {
          searchResults.value = response.data;
          isOpen.value = true;
          searchError.value = false;
        })
        .catch((error) => {
          if (error.name !== 'CanceledError') {
            console.error(error);
          }
        })
        .finally(() => {
          isLoading.value = false;
          controller = null;
        });
    }, 500);
  } else {
    isLoading.value = false;
    searchResults.value = [];
    isOpen.value = false;
    searchError.value = true;
  }
};

watch(search, performSearch);



const addItemToList = (item) => {
  if (!item.title || !item.title.length) return;

  emit('addItem', {
    ...item,
    variants: item.variants || null,
    selectedVariant:
      item.variants && item.variants !== 'custom'
        ? item.variants[0].single_dosage
        : null,
    quantity: 1,
  });

  if (controller) {
    controller.abort();
    controller = null;
  }

  isLoading.value = false;
  search.value = '';
  searchResults.value = [];
  isOpen.value = false;
  searchError.value = false;
};


return (_ctx, _cache) => {
  return (__props.selectedMedications.length < 1)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        tabindex: "-1",
        onFocusin: _cache[4] || (_cache[4] = $event => (toggleIsOpen(true))),
        onFocusout: _cache[5] || (_cache[5] = $event => (toggleIsOpen(false))),
        class: "SearchForm w-full relative"
      }, [
        (__props.selectedMedications.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectedMedications, (medication, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "flex items-center justify-between p-2 border-b"
                }, [
                  _createElementVNode("span", null, _toDisplayString(medication.title), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": $event => ((medication.quantity) = $event),
                    min: "1",
                    class: "w-16 p-1 border rounded ml-4 text-center"
                  }, null, 8, _hoisted_3), [
                    [_vModelText, medication.quantity]
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["SearchForm__searchInput", {
        'SearchForm__searchInput--hasErrors': __props.hasErrors,
        'border-red-500': searchError.value,
      }]),
          type: "text",
          placeholder: "Wpisz nazwę Ieku",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((search).value = $event)),
          onKeyup: _cache[1] || (_cache[1] = _withKeys($event => {performSearch();}, ["enter"])),
          onFocusout: validateSearch
        }, null, 34), [
          [_vModelText, search.value]
        ]),
        _createElementVNode("button", {
          class: "Button--no-style SearchForm__submitButton flex items-center justify-center",
          type: "button",
          disabled: isLoading.value,
          onClick: _cache[2] || (_cache[2] = $event => {performSearch();})
        }, [
          _createElementVNode("span", _hoisted_5, [
            (!isLoading.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
              : (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_12))
          ])
        ], 8, _hoisted_4),
        _withDirectives(_createElementVNode("div", _hoisted_13, [
          (!searchResults.value.length && search.value.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "Button--no-style SearchForm__list-item",
                onClick: _cache[3] || (_cache[3] = $event => (addItemToList({ title: search.value, variants: 'custom' })))
              }, [
                _createTextVNode(" Nie znaleziono Ieków w bazie. "),
                _hoisted_14
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "Button--no-style SearchForm__list-item",
              key: item.id,
              onClick: $event => (addItemToList(item))
            }, _toDisplayString(item.title), 9, _hoisted_15))
          }), 128))
        ], 512), [
          [_vShow, isOpen.value && !isLoading.value]
        ])
      ], 32))
    : _createCommentVNode("", true)
}
}

}